module.exports = {
	"sv": {
		"hqm": {
			"support-button": "Få hjälp",
			"support-page": {
				"create-ticket": {
					"title": "Få hjälp",
					"instructions": "Skicka en förfrågan nedan så hör vi av oss till dig.",
					"fields": {
						"mid": {
							"label": "Välj butik",
							"validation": "Du måste välja en butik"
						},
						"topic": {
							"question": "Vad är din fråga relaterad till?",
							"label": "Välj ett ämne",
							"validation": "Du måste välja ett ämne",
							"options": {
								"orders": "Beställningar",
								"settlements": "Avräkningar",
								"agreements": "Avtal",
								"technical_issues": "Tekniska problem",
								"others": "Övriga"
							}
						},
						"subject": {
							"label": "Ämne",
							"validation": "Du måste ange ett ämne"
						},
						"description": {
							"label": "Meddelande",
							"validation": "Du måste ange en beskrivning"
						},
						"attachment": {
							"label": "Lägg till bilaga",
							"button": "Ladda upp",
							"info": "Lägg till skärmdumpar så att vi kan lösa problemet snabbare.",
							"supportedFileTypes": "Filtyper som stöds: .png, .jpg, .pdf",
							"error": "Total filstorlek måste vara under 15 MB"
						}
					},
					"submit": "Skicka förfrågan",
					"service-unavailable-error": "Oj! Något gick fel. Försök igen om några minuter. Om problemet kvarstår, {link} för hjälp.",
					"contact-page-link": "kontakta oss"
				},
				"view-ticket": {
					"title": "Klart!",
					"details": "Vi har tagit emot din förfrågan och återkommer snart. Här är dina uppgifter:",
					"ticket": "Ärende #{ticketId}",
					"email": "E-postadress: {email}",
					"status": "Du kan se status för ditt ärende på vår Supportsida.",
					"track": "Se status"
				}
			},
			"popup": {
				"yes": "Ja",
				"no": "Nej",
				"somethingElse": "Jag behöver hjälp med någonting annat"
			},
			"header": {
				"homeLink": "Återställ"
			},
			"home": {
				"greeting": "Hej, {givenName}! Hur kan vi hjälpa dig?",
				"topics": "Vad behöver du hjälp med?"
			},
			"topics": {
				"expandButton": "Mer"
			},
			"moreHelp": {
				"relatedArticlesParagraph": "Vi är ledsna att det här inte hjälpte. Kanske kan några av dessa artiklar hjälpa dig?",
				"stillQuestionsTitle": "Har du fortfarande frågor?",
				"stillQuestionsParagraph": "Du kan också kontakta oss direkt.",
				"contactButton": "Kontakta oss"
			},
			"feedback": {
				"title": "Var det här till hjälp?",
				"optionYes": "Ja, det var till hjälp",
				"optionNo": "Nej, jag behöver mer hjälp",
				"positiveFeedback": "Tack för din positiva feedback. Detta hjälper oss att erbjuda dig mer relevanta artiklar i framtiden."
			},
			"freeTextFeedback": {
				"title": "Hjälp oss att bli bättre",
				"placeholder": "Varför tyckte du inte att innehållet var användbart?",
				"submitButton": "Skicka",
				"feedbackMessage": "Tack för din feedback. Detta hjälper oss att erbjuda dig mer relevanta artiklar i framtiden."
			},
			"relatedContent": {
				"title": "Relaterat innehåll"
			},
			"search": {
				"buttonLabel": "Sök",
				"input": "Söker efter artiklar...",
				"loading": "Laddar …",
				"results": {
					"contact": "Kan du inte hitta vad du behöver?",
					"empty": "Tyvärr hittades inga resultat för din fråga. Försök att söka efter en annan term.",
					"singleTopicFound": "Vi har hittat 1 ämne",
					"multipleTopicsFound": "Vi har hittat {count} ämnen",
					"singleArticleFound": "Vi har hittat 1 artikel",
					"multipleArticlesFound": "Vi har hittat {count} artiklar"
				}
			},
			"contact": {
				"title": "Kontakta oss",
				"channelsIntro": "Hör av dig till oss så att vi kan hjälpa dig",
				"businessDetailsTitle": "Dina företagsuppgifter",
				"businessDetailsName": "Företagsnamn",
				"businessDetailsEmail": "E-mail",
				"businessDetailsMid": "Butiks-ID",
				"phone": {
					"title": "Ring oss",
					"paragraph": "Du kan ringa oss under arbetstid på vardagar. Om du befinner dig i Sverige eller Storbritannien kan du även ringa oss på helger mellan klockan 10-16."
				},
				"chat": {
					"title": "Chatta med oss",
					"paragraph": "Det snabbaste och enklaste sättet att nå kundservice. Vår chatt är öppen för tillfället.",
					"button": "Öppna chatt"
				},
				"email": {
					"title": "Skicka e-post till oss",
					"paragraph": "Skicka ett e-postmeddelande så hör vi av oss så snart vi kan."
				}
			},
			"errorBoundary": {
				"title": "Något gick fel",
				"message": "Vi beklagar, men tyvärr uppstod ett fel. Klicka på knappen nedan för att återställa och stänga den här sidopanelen.",
				"resetButton": "Återställ",
				"errorId": "Fel-ID: {errorId}"
			},
			"tour": {
				"prev": "Föregående",
				"next": "Nästa",
				"done": "Klar"
			},
			"notAvailableMobile": {
				"title": "Ej tillgänglig",
				"buttonBack": "Tillbaka",
				"paragraph": "Detta innehåll är inte tillgängligt på din enhet. Försök att öppna det på en enhet med större skärm så som en stationär dator."
			},
			"shareButton": {
				"title": {
					"article": "Dela en djuplänk till den här artikeln",
					"topic": "Dela en djuplänk till det här ämnet",
					"tour": "Dela en djuplänk till den här rundturen"
				},
				"radioItemHome": "Hemapp",
				"descriptionHome": "Öppna hjälpartiklar på Butikportalens hemsida",
				"radioItemCurrent": "Aktuell sida",
				"descriptionCurrent": "Öppna hjälpartiklar på aktuell sida"
			}
		},
		"orientation": {
			"title": "Lär dig hur man..."
		},
		"core": {
			"alert": {
				"message": "Något gick fel! Vänligen försök igen.",
				"correlationIdLabel": "Korrelations-ID:"
			},
			"header": {
				"title": "Merchant Portal"
			},
			"usermenu": {
				"language": "Språk",
				"country": "Land",
				"timezone": "Tidszon",
				"logout": "Logga ut",
				"profile": "Profil",
				"changeProfile": "Ändra",
				"tooltip": "Din profil"
			},
			"appsmenu": {
				"defaultTooltip": "Dina appar",
				"initialTooltip": "Hitta dina appar här.",
				"newAppsTooltip": "Vi har nya appar till dig!"
			},
			"helpful-question-mark": {
				"helpLabel": "Hjälp"
			},
			"languages": {
				"da": "Danska",
				"de": "Tyska",
				"en": "Engelska",
				"en_GB": "Engelska (GB)",
				"en_US": "Engelska (US)",
				"es": "Spanska",
				"fi": "Finska",
				"fr": "Franska",
				"it": "Italienska",
				"nl": "Nederländska",
				"no": "Norska",
				"sv": "Svenska"
			},
			"countries": {
				"de": "Tyskland",
				"dk": "Danmark",
				"fi": "Finland",
				"gb": "England",
				"nl": "Nederländerna",
				"no": "Norge",
				"se": "Sverige",
				"us": "USA"
			},
			"selectLanguage": {
				"title": "Välj språk",
				"paragraph": "Det här kommer vara ditt förvalda språk. ",
				"submit": "OK"
			},
			"selectCountry": {
				"title": "Välj ditt land",
				"paragraph": "Det här kommer vara ditt förvalda land.",
				"submit": "OK"
			},
			"updateProfile": {
				"title": "Uppdatera uppgifter",
				"submit": "OK",
				"emailLabel": "Mejladress",
				"firstNameLabel": "Förnamn",
				"lastNameLabel": "Efternamn",
				"resetPasswordLabel": "Återställ lösenord",
				"resetPasswordSuccessLabel": "E-post för återställning av lösenord skickat",
				"resetPasswordErrorLabel": "Fel uppstod med e-post för återställning av lösenord",
				"error": "Uppdatering av uppgifter misslyckades"
			},
			"footer": {
				"copyright": {
					"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Med ensamrätt",
					"oc": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579",
					"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215"
				},
				"terms": "Villkor"
			},
			"accessDenied": {
				"title": "Du behöver utökad åtkomst för den här sidan. ",
				"message": "Kontakta din administratör eller Klarna vid frågor."
			},
			"midSelector": {
				"label": "Butik"
			},
			"storeSelector": {
				"label": "Butik"
			},
			"storesSelector": {
				"closeText": "Klar",
				"closeTextWithSelection": "Applicera # val",
				"deselectAllOptionText": "Rensa val",
				"emptyStateText": "Inga butiker hittades",
				"label": "Butiker",
				"searchFieldLabel": "Sök efter butik",
				"selectAllOptionText": "Välj alla butiker",
				"selectedAllText": "Alla butiker",
				"selectedText": "# butiker"
			},
			"pagination": {
				"ofLabel": "av",
				"noResultsLabel": "Inga resultat"
			},
			"dateRangePicker": {
				"startLabel": "Startdatum",
				"endLabel": "Slutdatum",
				"months": {
					"january": "Januari",
					"february": "Februari",
					"march": "Mars",
					"april": "April",
					"may": "Maj",
					"june": "Juni",
					"july": "Juli",
					"august": "Augusti",
					"september": "September",
					"october": "Oktober",
					"november": "November",
					"december": "December"
				},
				"weekDaysShort": {
					"monday": "M",
					"tuesday": "T",
					"wednesday": "O",
					"thursday": "T",
					"friday": "F",
					"saturday": "S",
					"sunday": "S"
				}
			},
			"appIcon": {
				"newLabel": "NYHET"
			},
			"appCategory": {
				"dayToDay": "För ditt dagliga arbete",
				"nko": "Klarna Online",
				"tools": "Verktyg",
				"preferences": "Inställningar"
			},
			"apps": {
				"home-fe": {
					"title": "Hem"
				},
				"nko-app": {
					"title": "Appar för Klarna Online"
				},
				"orders-fe": {
					"title": "Beställningar",
					"description": "Sök och hantera dina beställningar från Klarna.",
					"nkoLinkText": "Se äldre beställningar"
				},
				"nko-orders": {
					"title": "Ordrar (KO)",
					"description": "Sök och hantera dina beställningar som gjorts genom Klarna Online."
				},
				"settlements-fe": {
					"title": "Avräkningar",
					"description": "Se dina transaktioner och generera rapporter för avstämning.",
					"nkoLinkText": "Se äldre rapporter"
				},
				"nko-settlements": {
					"title": "Avräkningar (KO)",
					"description": "Hitta rapporter på beställningar och utbetalningar från Klarna Online."
				},
				"logs-app-fe": {
					"title": "Loggar",
					"description": "Sök API-loggar för att felsöka integrationsproblem."
				},
				"users-fe": {
					"title": "Användare",
					"description": "Bjud in nya och hantera befintliga användare i portalen."
				},
				"settings-fe": {
					"title": "Inställningar",
					"description": "Begär ut dina Klarna API-nycklar och hantera butiksinställningar."
				},
				"nko-settings": {
					"title": "Inställningar (KO)",
					"description": "Hantera dina butiksinställningar, rapporter och kontaktdetaljer."
				},
				"seller-fe": {
					"title": "Point of Sale",
					"description": "Skapa nya beställningar med Klarnas lösning för köp i butik."
				},
				"products-fe": {
					"title": "Produkter",
					"description": "Visar dig hur du får ut det mesta av Klarna."
				},
				"upstream-fe": {
					"title": "On-site messaging",
					"description": "Sälj mer med skräddarsydda och personliga finansieringserbjudanden."
				},
				"lending-fe": {
					"title": "Företagslån",
					"description": "Företagslån, fast enklare."
				},
				"branding-fe": {
					"title": "Varumärkeshantering",
					"description": "Ta kontroll över hur ditt varumärke presenteras inom Klarna."
				},
				"disputes-fe": {
					"title": "Tvister",
					"description": "Hantera dina tvister."
				},
				"logistics-fe": {
					"title": "Logistik",
					"description": "Hantera all din logistik på ett ställe."
				},
				"ob-transactions-fe": {
					"title": "Transaktioner",
					"description": "Open Banking-transaktioner"
				},
				"developers": {
					"title": "Utvecklare"
				},
				"product-upgrade-fe": {
					"title": "Produktuppgradering"
				},
				"marketing": {
					"title": "Marknadsföring",
					"description": "Hitta marknadsföringsmaterial för att utöka din verksamhet här."
				},
				"business-card-fe": {
					"title": "Företagskort",
					"description": "Kommer snart"
				},
				"support": {
					"title": "Support",
					"description": "Kontrollera och hantera dina supportärenden."
				}
			},
			"ui": {
				"buttons": {
					"backButton": "Tillbaka"
				}
			},
			"errorBoundary": {
				"contact": "Pröva att uppdatera sidan. {br}Om felet kvarstår, kontakta <supportLink>Kundservice för handlare</supportLink> och ange fel-ID {errorId}",
				"errorDescription": "Fel-ID - {errorId}",
				"reloadButton": "Uppdatera",
				"title": "Tyvärr uppstod ett fel"
			},
			"maintenance": {
				"pageTitle": "Underhåll",
				"title": "Portalen för handlare genomgår schemalagt underhåll för närvarande",
				"summary": "Vi är strax tillbaka",
				"scheduledSummary": "Vi är tillbaka {until}"
			}
		},
		"blackFriday": {
			"v1": {
				"title": "Black Friday",
				"intro": "En av de viktigaste shoppingdagarna är snart här. Vi kommer att finnas här för att leverera den senaste försäljningsstatistiken under Black Friday, men nu är det dags att förbereda sig för framgång!",
				"countdown": "Startar om #dd #ht #mm #ss…",
				"box1": {
					"title": "3,5x högre spenderande*",
					"text": "Förra året spenderade Klarnas shoppare* i genomsnitt 3,5x mer under Black Friday än under någon annan dag på året.",
					"footnote": "*Genomsnitt för alla Klarnas regioner och kategorier av handlare."
				},
				"box2": {
					"title": "2,5x högre försäljningsvolym*",
					"text": "Förra året genererade Klarnas handlare i genomsnitt 2,5x högre försäljningsvolym under Black Friday än under någon annan dag på året.",
					"footnote": "*Genomsnitt för alla Klarnas regioner och kategorier av handlare."
				},
				"sectionTitle": "Öka din försäljning under Black Friday",
				"marketing": {
					"title": "Marknadsför din verksamhet före och under Black Friday",
					"text": "Få fler shoppare till din butik under Black Friday-säsongen med dessa gratisresurser för sociala medier och e-postkampanjer."
				},
				"branding": {
					"title": "Bli sedd i Klarna-appen",
					"text": "12 miljoner shoppare använder Klarna-appen varje månad. Se till att du syns i appen under Black Friday genom att lägga till och uppdatera din varumärkesinformation här i butiksportalen."
				},
				"cta": "Kom igång",
				"close": "Stäng"
			},
			"v2": {
				"title": "Black Friday week",
				"orderVolume": "Ordervolym",
				"orderCountTitle": "Skapade ordrar",
				"orderCount": "{count} ordrar",
				"box": {
					"title": "Vill du öka din konvertering ytterligare?",
					"subtitle1": "On-site Messaging",
					"subtitle2": "Kampanjmeddelanden som utbildar kunder.",
					"text": "Vårt On-site messaging-verktyg ökar din försäljning och dina genomsnittliga ordervärden med hjälp av kampanjmeddelanden. Berätta för shoppare vilka betalningsalternativ som finns tillgängliga när de kommer till din sida och under hela deras besök.",
					"cta": "Kom igång"
				},
				"selector": {
					"done": "Klar",
					"applySelection": "Applicera # val",
					"selectAll": "Välj alla",
					"allOptions": "Alla alternativ valda",
					"someOptions": "# alternativ valda",
					"storeMultiSelectLabel": "Välj # butiker",
					"allStores": "Alla butiker"
				},
				"currencyLabel": "Välj valuta",
				"storeLabel": "Välj butik"
			},
			"v3": {
				"title": "Black Friday week",
				"text": "Här är din försäljning från en av årets viktigaste försäljningsveckor.",
				"summaryTitle": "Sammanfattning ",
				"orderVolume": "Total ordervolym",
				"orderCount": "Totalt antal ordrar",
				"summaryRange": "23-30 November",
				"comparisonLastWeek": "jämfört med samma dag, förra veckan",
				"tabs": {
					"monday": "Måndag",
					"tuesday": "Tisdag",
					"wednesday": "Onsdag",
					"thursday": "Torsdag",
					"blackFriday": "Black Friday",
					"saturday": "Lördag",
					"sunday": "Söndag",
					"cyberMonday": "Cyber Monday"
				}
			}
		}
	}
};